import { Injectable } from '@angular/core';

import { CompareValue, OutputValue } from '@shared/components/compare-value/model';

import { includes, isUndefined } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class CompareValueService {
  public matches(value: number, compareValue: OutputValue): boolean {
    let result = true;

    if (compareValue?.id && !isUndefined(value)) {
      const isRange = includes([
        CompareValue.GreaterThanEqualLessThanEqual,
        CompareValue.GreaterThanLessThan
      ], compareValue.id);

      if (isRange && compareValue.min && compareValue.max) {
        if (compareValue.id === CompareValue.GreaterThanLessThan) {
          result = compareValue.min < value && value < compareValue.max;
        } else if (compareValue.id === CompareValue.GreaterThanEqualLessThanEqual) {
          result = compareValue.min <= value && value <= compareValue.max;
        }
      } else if (compareValue.min) {
        if (compareValue.id === CompareValue.EqualTo) {
          result = value === compareValue.min;
        } else if (compareValue.id === CompareValue.LessThan) {
          result = value < compareValue.min;
        } else if (compareValue.id === CompareValue.GreaterThan) {
          result = value > compareValue.min;
        } else if (compareValue.id === CompareValue.NotEqualTo) {
          result = value !== compareValue.min;
        }
      }
    }

    return result;
  }
}
